import mutations from "./mutations";
import * as actions from "./actions";
import { initial_label, initial_labels, initial_pagination } from "./initialState";

let state = {
    gapi: null,
    is_signed_in: false,
    label: initial_label,
    labels: { ...initial_labels },
    message: null,
    messages: [],
    pagination: { ...initial_pagination, navigationObject: {...initial_pagination.navigationObject} },
    profile: {
        auth: null,
        email: '',
        id: 0,
        imageUrl: '',
        name: '',
    },
    query: '',
}

export default { mutations, actions, state }